import {
  RESET_DATA,
  FETCHING_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAIL
} from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  data: [],
  errorMsg: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_DATA:
      return { ...INITIAL_STATE }
    case FETCHING_DATA:
      return { ...INITIAL_STATE, loading: true }
    case FETCH_DATA_SUCCESS:
      return { ...state, data: action.payload, loading: false }
    case FETCH_DATA_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listReducer.js